module.exports = "/_next/static/images/8a3d0eeeaa885535f0fb76284499778d-nubank-outdoor-md@1x.jpg.webp";